'use strict';

// adapt the layout of the shared count criterium
// to look better with competitors

var putSidInArray = require('./putSidInArray');
var addTabsForSiComp = require('./addTabsForSiComp');
var addMainDataInSiComp = require('./addMainDataInSiComp');
var prettifyBigNumbers = require('../prettifyBigNumbers');

prettifyBigNumbers.init();

function competizeSharedCount () {
  var current;
  var dataLength;
  var graphTmp;
  var id = 0;
  var max;
  var percent;
  var progressBarHtml;
  var totalTmp;
  var url;
  var $this = $(
    '#criterium-shared_count.criterium-have-comp:not(.is-competized)'
  );
  var $content = $this.find('>div.criterium-content');
  var $comp = $this.find('>div.competitor-content');
  var data = {};

  if ($this.length === 1 && $content.length === 1 && $comp.length > 0) {
    $this.addClass('is-competized');
    data = putSidInArray($content, data, 0);

    $comp.each(function () {
      var obj;
      obj = $(this);
      id++;
      data = putSidInArray(obj, data, id);
      return data;
    });

    dataLength = Object.keys(data).length;

    $comp.each(function () {
      var obj;
      obj = $(this);
      return addMainDataInSiComp(obj, data, dataLength);
    });

    addTabsForSiComp($content, data, dataLength);

    // replace main content by progress bar
    max = 0;

    for (url in data) {
      totalTmp = data[url].total;
      if (totalTmp > max) {
        max = totalTmp;
      }
    }

    max *= 1.05;
    progressBarHtml = '';

    for (url in data) {
      current = data[url];
      percent = parseInt(current.total / max * 100, 10);

      if (percent < 3) {
        percent = 3;
      }
      graphTmp = {
        graph_progressbar: {
          htmlclass: percent < 33 ? 'low-percent' : false,
          percent: percent,
          title: current.url,
          value: current.total
        }
      };

      progressBarHtml += window.Mustache.render([
        '<div class="part progressbar {{htmlclass}}">',
        '    {{#title}}<p class="title"><span class="color"></span>{{{title}}}</p>{{/title}}',
        '    <div class="content{{#min}} has-min{{/min}}{{#max}} has-max{{/max}}{{#title}} has-title{{/title}}">',
        '        {{#min}}<span class="min">{{min}}</span>{{/min}}',
        '        {{#max}}<span class="max">{{max}}</span>{{/max}}',
        '        <span class="bar"><span class="colored-bar" style="width:{{percent}}%;">{{#value}}{{value}}&nbsp;&nbsp;&nbsp;&nbsp;{{/value}}</span>{{#value}}<span class="value" data-abs-value="{{absValue}}">{{value}}</span>{{/value}}</span>',
        '    </div>',
        '</div>'
      ].join('\n'),
      graphTmp.graph_progressbar
      );
    }

    $content.addClass('full-width').html(progressBarHtml);
    $content.find('.part.progressbar').prettifyBigNumbers();
    $comp.find('table.social-media-compare').prettifyBigNumbers();
  }
}

module.exports = competizeSharedCount;
